import { render, staticRenderFns } from "./SampleMessages.vue?vue&type=template&id=1c30c672&scoped=true&"
import script from "./SampleMessages.vue?vue&type=script&lang=js&"
export * from "./SampleMessages.vue?vue&type=script&lang=js&"
import style0 from "./SampleMessages.vue?vue&type=style&index=0&id=1c30c672&lang=scss&scoped=true&"
import style1 from "./SampleMessages.vue?vue&type=style&index=1&id=1c30c672&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c30c672",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c30c672')) {
      api.createRecord('1c30c672', component.options)
    } else {
      api.reload('1c30c672', component.options)
    }
    module.hot.accept("./SampleMessages.vue?vue&type=template&id=1c30c672&scoped=true&", function () {
      api.rerender('1c30c672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/campaigns/SampleMessages.vue"
export default component.exports